import React from 'react'

const ErrorPage = () => {
  return <div>This page dose not exist!</div>
}

export default ErrorPage
